<template>
  <div>
    <div id="div_Paysuss"
         style="display:none">
      <div style="margin:0px auto; display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <div style="margin-top:180px;display: flex;border:1px solid #65a040;padding:70px 200px 80px;border-radius: 5px;background-color: #f8f8f8;">
          <div style="width:50px;height:50px; background-color: #65a040;border-radius: 50%;">
            <!-- <img src="~/images/wepayok.png"
                 style="width:32px;height:32px;margin:9px;" /> -->
          </div>
          <div style="margin-left:20px">
            <p style="font-size:18px;font-weight:800;line-height:50px;">恭喜您，支付成功啦！</p>
            <p style="font-size:16px;margin-top:20px;line-height:30px;">支付方式：微信</p>
            <p style="font-size:16px;margin-top:10px;line-height:30px;">支付金额：￥1000.00元</p>
            <div style="display: flex;margin-top:30px;">
              <div style="cursor: pointer;margin-right:10px;font-size:15px;width:120px;height:30px;background-color: #65a040;color:#fff;line-height:30px;text-align: center;">查看订单</div>
              <div style="cursor: pointer;font-size:15px;width:120px;height:30px;background-color: #eee;line-height:30px;text-align: center;">继续购买</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: []
    };
  },
  created () {
    this.httphelper
      .post('/api/CGPEnterPriseApi/GetOrganProjectList', {
        orgId: 0
      })
      .then(res => {
        if (res.data.code == 200 && res.data.data.organList.length > 0) {
          this.list = res.data.data.organList
          if (this.list.length < 8) {
            this.list = this.list.concat(this.list).slice(0, 7)
          }
        }
      });
  },
  methods: {
  }
};
</script>

<style scoped>
.div {
    position: fixed;
    top: 200px;
    left: 50%;
    margin-left: 50%;
    width: 200px;
    height: 200px;
    background-color: rgba(0, 0, 0, 0.644);
    border-radius: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    background-color: #f8f8f8;
    text-align: center;
    cursor: pointer;
    border: 1px solid;
    overflow: hidden;
}
</style>